import React from 'react';
import { RedocStandalone } from 'redoc';
import { DocsSidebar } from '../components/DocsSidebar';
import { SIDEBAR_BG } from '../components/DocsSidebar/style';
import { Header, HEADER_HEIGHT, SIDEBAR_WIDTH } from '../components/Header';
interface DocsViewProps {
  onLogout: () => void;
}

const getRedocOptions = () => ({
  hideDownloadButton: true,
  hideFab: true,
  minCharacterLengthToInitSearch: 1,
  scrollYOffset: HEADER_HEIGHT,
  expandResponses: '200',
  theme: {
    colors: { primary: { main: '#4F73F7' } },
    typography: {
      fontFamily: "'Poppins', sans-serif",
      fontSize: '13px',
      fontWeightRegular: '500',
      headings: {
        fontFamily: "'Poppins', sans-serif",
        fontWeight: '600',
        lineHeight: '0',
      },
    },
    sidebar: {
      width: `${SIDEBAR_WIDTH}px`,
      backgroundColor: SIDEBAR_BG,
      textColor: '#cbd5e1',
    },
    rightPanel: { backgroundColor: SIDEBAR_BG, textColor: '#e2e8f0', width: '40%' },
    logo: { maxHeight: '0px', maxWidth: '0px' },
  },
});

export const DocsView: React.FC<DocsViewProps> = ({ onLogout }) => (
  <>
    <DocsSidebar />
    <Header onLogout={onLogout} />
    <RedocStandalone specUrl="/zorro-api.yaml" options={getRedocOptions()} />
  </>
);
